import { render, staticRenderFns } from "./customer-step.vue?vue&type=template&id=00aca704&"
import script from "./customer-step.vue?vue&type=script&lang=js&"
export * from "./customer-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports